import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mypage');
import { OnInit, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-mypage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.mypage/view.scss */
:host {
  display: block;
}`],
})
export class PageMypageComponent implements OnInit {

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR) { }

    /** 사용자 정보 */
    public user: any = null;
    /** 참여 프로젝트 목록 */
    public projects: any[] = [];
    /** 상태 통계 */
    public stats: any = { '진행중': 0, '대기': 0, '완료': 0, '중단': 0 };

    /** 활성 탭 (profile | password | projects) */
    public activeTab: string = 'profile';

    /** 프로필 편집 모드 */
    public isEditing: boolean = false;
    /** 프로필 편집 데이터 */
    public editData: any = { name: '', email: '', department: '' };

    /** 비밀번호 변경 데이터 */
    public pwData: any = { current_password: '', new_password: '', confirm_password: '' };
    /** 비밀번호 변경 에러 */
    public pwError: string = '';
    /** 비밀번호 변경 성공 */
    public pwSuccess: string = '';

    /** 부서 목록 */
    public departments: string[] = ['건축', '토목', '기타'];

    public async ngOnInit() {
        await this.service.init(this);
        await this.load();
        await this.service.loading.hide();
        this.ref.detectChanges();
    }

    public async load() {
        const { code, data } = await wiz.call("load");
        if (code === 200) {
            this.user = data.user;
            this.projects = data.projects;
            this.stats = data.stats;
            this.editData = {
                name: this.user.name || '',
                email: this.user.email || '',
                department: this.user.department || ''
            };
        }
        this.ref.detectChanges();
    }

    /** 탭 전환 */
    public switchTab(tab: string) {
        this.activeTab = tab;
        this.pwError = '';
        this.pwSuccess = '';
        this.ref.detectChanges();
    }

    /** 프로필 편집 시작 */
    public startEdit() {
        this.editData = {
            name: this.user.name || '',
            email: this.user.email || '',
            department: this.user.department || ''
        };
        this.isEditing = true;
        this.ref.detectChanges();
    }

    /** 프로필 편집 취소 */
    public cancelEdit() {
        this.isEditing = false;
        this.ref.detectChanges();
    }

    /** 프로필 저장 */
    public async saveProfile() {
        const { code, data } = await wiz.call("update_profile", this.editData);
        if (code === 200) {
            await this.service.alert.show({
                title: '성공',
                message: '프로필이 수정되었습니다.',
                action: '확인'
            });
            this.isEditing = false;
            await this.load();
        } else {
            await this.service.alert.show({
                title: '오류',
                message: data.message || '프로필 수정에 실패했습니다.',
                action: '확인'
            });
        }
    }

    /** 비밀번호 변경 */
    public async changePassword() {
        this.pwError = '';
        this.pwSuccess = '';

        if (!this.pwData.current_password || !this.pwData.new_password || !this.pwData.confirm_password) {
            this.pwError = '모든 항목을 입력하세요.';
            this.ref.detectChanges();
            return;
        }
        if (this.pwData.new_password !== this.pwData.confirm_password) {
            this.pwError = '새 비밀번호가 일치하지 않습니다.';
            this.ref.detectChanges();
            return;
        }
        if (this.pwData.new_password.length < 4) {
            this.pwError = '비밀번호는 4자 이상이어야 합니다.';
            this.ref.detectChanges();
            return;
        }

        const { code, data } = await wiz.call("change_password", this.pwData);
        if (code === 200) {
            this.pwSuccess = '비밀번호가 변경되었습니다.';
            this.pwData = { current_password: '', new_password: '', confirm_password: '' };
        } else {
            this.pwError = data.message || '비밀번호 변경에 실패했습니다.';
        }
        this.ref.detectChanges();
    }

    /** 날짜 포맷 */
    public formatDate(dateStr: string): string {
        if (!dateStr) return '-';
        const date = new Date(dateStr);
        return `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, '0')}.${String(date.getDate()).padStart(2, '0')}`;
    }

    /** 상태 스타일 */
    public getStatusClass(status: string): string {
        const styles: any = {
            '대기': 'bg-gray-100 text-gray-500',
            '진행중': 'bg-blue-50 text-blue-600',
            '완료': 'bg-emerald-50 text-emerald-600',
            '중단': 'bg-red-50 text-red-600'
        };
        return styles[status] || 'bg-gray-100 text-gray-500';
    }

    /** 용역 카테고리 표시명 */
    public getCategoryLabel(category: string): string {
        const labels = String(category || '')
            .split(',')
            .map((item: string) => item.trim())
            .filter((item: string) => !!item)
            .map((item: string) => (item === '전체' || item === '기타(연구소)') ? '기타' : item);
        if (labels.length === 0) return '기타';
        return Array.from(new Set(labels)).join(', ');
    }

    /** 프로젝트 상세 이동 */
    public goDetail(projectId: string) {
        this.service.href(`/project/detail/${projectId}`);
    }
}

export default PageMypageComponent;